<template>
    <div>
        <div class='about-bg'>
            <el-image :src="about_header" style=" width: 100%; margin-bottom: 3%"></el-image>
            <div class="about-item">
<!--              <el-image v-show="$i18n.locale==='zh'" :src="about_content" class="about-item-zh" style="width: 64%"></el-image>-->
              <el-image v-show="$i18n.locale==='zh'" v-for="item in about_content" :src="item" :key="item" class="about-item-zh" style="width: 64%"></el-image>
              <el-image v-show="$i18n.locale==='en'" :src="about_content_en" class="about-item-en"></el-image>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data(){
    return {
      about_header: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_header.jpg',
      // about_content: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_1.png',
      // about_content: `${require('../assets/img_grande/about_us_0324.png')}`,
      // about_content: `${require('../assets/img_grande/about_us_0805.png')}`,
      about_content: [
          `${require('../assets/images_new/new_about1.png')}`,
          `${require('../assets/images_new/new_about2.png')}`,
          `${require('../assets/images_new/new_about3.png')}`,
          `${require('../assets/images_new/new_about4.png')}`,
          `${require('../assets/images_new/new_about5.png')}`,
          `${require('../assets/images_new/new_about6.png')}`,
      ]

    }
  },
  computed: {
    //是否使用移动端视频
    about_content_en() {
      // return document.documentElement.clientWidth > 992 ? 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_1_en.png' : 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_en_mobile.png';
      return document.documentElement.clientWidth > 992 ? `${require('../assets/resource_10_23/about_us_en.png')}` : 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/about_en_mobile.png';
    },
  },
}
</script>

<style>
.about-item {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-top: 50px;
}
.about-item-zh {
  width: 100%;
  /*margin-bottom: 3%*/
}
.about-item-en {
  width: 100%;
  /*margin-bottom: 3%*/
}
@media screen and (max-width: 926px) {
  .about-item {
    margin-top: 20px;
    width: 110%;
    right: 5%;
    position: relative;
  }
  .about-item-en {
    width: 70%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/About.vue